/**
 * LocalStore utility for managing authentication context in localStorage
 * Used for iframe integration with AIPF Portal
 */

const AUTHZ_COMPANY_ID_KEY = 'authz_company_id';
const AUTHZ_PROJECT_ID_KEY = 'authz_project_id';
const AUTHZ_TARGET_PROJECT_ID_KEY = 'authz_target_project_id';
const AUTHZ_SERVICE_NAME_KEY = 'authz_service_name';
const AUTHZ_METADATA_KEY = 'authz_project_metadata';

const localStore = {
  // Company ID
  setAuthzCompanyId(value: string): void {
    localStorage.setItem(AUTHZ_COMPANY_ID_KEY, value);
  },
  getAuthzCompanyId(): string | null {
    return localStorage.getItem(AUTHZ_COMPANY_ID_KEY);
  },
  removeAuthzCompanyId(): void {
    localStorage.removeItem(AUTHZ_COMPANY_ID_KEY);
  },

  // Project ID
  setAuthzProjectId(value: string): void {
    localStorage.setItem(AUTHZ_PROJECT_ID_KEY, value);
  },
  getAuthzProjectId(): string | null {
    return localStorage.getItem(AUTHZ_PROJECT_ID_KEY);
  },
  removeAuthzProjectId(): void {
    localStorage.removeItem(AUTHZ_PROJECT_ID_KEY);
  },

  // Target Project ID
  setAuthzTargetProjectId(value: string): void {
    localStorage.setItem(AUTHZ_TARGET_PROJECT_ID_KEY, value);
  },
  getAuthzTargetProjectId(): string | null {
    return localStorage.getItem(AUTHZ_TARGET_PROJECT_ID_KEY);
  },
  removeAuthzTargetProjectId(): void {
    localStorage.removeItem(AUTHZ_TARGET_PROJECT_ID_KEY);
  },

  // Service Name
  setAuthzServiceName(value: string): void {
    localStorage.setItem(AUTHZ_SERVICE_NAME_KEY, value);
  },
  getAuthzServiceName(): string | null {
    return localStorage.getItem(AUTHZ_SERVICE_NAME_KEY);
  },
  removeAuthzServiceName(): void {
    localStorage.removeItem(AUTHZ_SERVICE_NAME_KEY);
  },

  // Metadata
  setAuthzMetadata(value: string): void {
    localStorage.setItem(AUTHZ_METADATA_KEY, value);
  },
  getAuthzMetadata(): string | null {
    return localStorage.getItem(AUTHZ_METADATA_KEY);
  },
  removeAuthzMetadata(): void {
    localStorage.removeItem(AUTHZ_METADATA_KEY);
  },

  // Clear all authz data
  clearAuthzData(): void {
    this.removeAuthzCompanyId();
    this.removeAuthzProjectId();
    this.removeAuthzTargetProjectId();
    this.removeAuthzServiceName();
    this.removeAuthzMetadata();
  },
};

export default localStore;
